import { RefObject } from 'preact';
import { useState, useCallback } from 'preact/hooks';
import { useResizeObserver } from '../UNSAFE_useResizeObserver';

const useSize = (
  ref: RefObject<Element>,
  resizeObserverOptions: ResizeObserverOptions = { box: 'content-box' }
) => {
  const [size, setSize] = useState<{ width: number; height: number }>();

  useResizeObserver({
    ref,
    callback: useCallback(
      (entry) => {
        const boxSize =
          resizeObserverOptions.box === 'border-box' ? entry.borderBoxSize : entry.contentBoxSize;
        const newWidth = boxSize[0].inlineSize;
        const newHeight = boxSize[0].blockSize;
        setSize({ width: newWidth, height: newHeight });
      },
      [resizeObserverOptions]
    ),
    resizeObserverOptions
  });

  return size;
};

export { useSize };
